import {
	Component,
	OnInit,
	ViewEncapsulation,
	Input,
	OnChanges,
} from "@angular/core";

@Component({
	selector: "app-quiz-feedback",
	templateUrl: "./quiz-feedback.directive.html",
	styleUrls: ["./quiz-feedback.directive.css"],
	encapsulation: ViewEncapsulation.None,
})
export class QuizFeedbackDirective implements OnInit, OnChanges {
	@Input() title: String;
	@Input() bodyText: string;
	@Input() titleFontSize?: String;
	@Input() titleFontColor?: String;
	@Input() bodyTextFontSize?: String;
	@Input() bodyTextFontColor?: String;
	@Input() textDirection: string;

	constructor() {}

	ngOnInit() {}
	ngOnChanges(changes) {}
}
